import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import App from './App.vue'
import router from './router'
import 'unfonts.css'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { registerWindowErrorHandlers } from '@/utils/errorHandler.ts'
import Vue3TouchEvents, { type Vue3TouchEventsOptions } from 'vue3-touch-events'

//Register window events like unhandledrejection and error
registerWindowErrorHandlers()

const app = createApp(App)
app
  .use(createPinia())
  .use(i18n)
  .use(vuetify)
  .use(router)
  .use(VueVirtualScroller)
  .use<Vue3TouchEventsOptions>(Vue3TouchEvents, {
    disableClick: false
    // any other global options...
  })
  .mount('#app')
